import { useQuery } from '@tanstack/react-query';
import { bff } from 'shared/api';
import {
  ResourceNamespaceListReply,
  ResourceNamespaceListRequest,
} from 'shared/types/protoc-gen/bffbillsystem';
import { QUERY_KEYS } from 'shared/types/react-query';

const useGetRollupNamespaces = (params: ResourceNamespaceListRequest) => {
  return useQuery<ResourceNamespaceListReply>({
    queryKey: [QUERY_KEYS.ADMIN_COST_ROLLUP_NAMESPACES, params.type],
    queryFn: async () => {
      const res = await bff.get<ResourceNamespaceListReply>('/bff/cost/resource_namespaces', {
        params,
      });

      const sortedNamespaces = res.data.namespace.sort((a, b) => a.localeCompare(b));

      const data = {
        namespace: sortedNamespaces,
      };

      return data;
    },
  });
};

export default useGetRollupNamespaces;
